import React from "react";
import Modal from "../shared/Modal";
import ActionButton from "../common/ActionButton";
import "./ModalUnsavedChanges.css";
import { Button } from "../../ds2/components";

interface ModalUnsavedChangesProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  onDiscard: () => void;
}

export const ModalUnsavedChanges: React.FC<ModalUnsavedChangesProps> = ({
  isOpen,
  onClose,
  onSave,
  onDiscard,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "500px" }}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="modal-unsaved-changes">
        <div className="modal-unsaved-changes-content">
          <span style={{ color: "var(--text-color-secondary)" }}>
            You have unsaved changes in the editor. Please save your changes
            before proceeding.
          </span>
        </div>

        <div className="modal-unsaved-changes-buttons">
          <Button label="Cancel" variant="primary" onClick={onClose} />
          <Button
            label="Discard Changes"
            variant="primary"
            onClick={onDiscard}
          />
          <Button
            label="Save Changes"
            variant="tertiary"
            onClick={onSave}
          />
        </div>
      </div>
    </Modal>
  );
};
